
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"

@Component({name: "DisclaimerPage", components: {Page}})
export default class DisclaimerPage extends AbstractPage {}
